import React, { useEffect, useState, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import "./AllCard.css";
import { getContestPieChart } from "../../../api/contest";
import { fPercentExact } from "../../../helper/formatNumber";

const locale = require("react-redux-i18n").I18n;

const PieChartContest = ({ status }) => {
  const [data, setData] = useState();
  const contestId = localStorage.getItem("contestId");

  const labels = useMemo(
    () => data?.data.map((e) => e.s.replace(".iux", "")) || [],
    [data]
  );

  const series = useMemo(
    () => data?.data.map((e) => e.percentage) || [],
    [data]
  );

  const fetchContestPieChart = async () => {
    try {
      const data = await getContestPieChart({ id: contestId });
      if (data.data?.data?.length > 0) {
        setData(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContestPieChart();
  }, []);

  const options = {
    colors: ["#33B1FF", "#F8D96A", "#50B97A"],
    labels: labels,
    chart: {
      width: 380,
      type: "donut",
    },
    plotOptions: {
      pie: {
        donut: {
          size: "50%",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `${value}%`,
      },
      style: {
        fontSize: "14px",
        fontFamily: "Arial",
        color: "#333",
      },
      theme: "light",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: {
      show: false,
    },
  };

  return (
    <div
      className="border d-flex p-24 flex-column box-toptrade"
      style={{ borderRadius: "8px", height: "487px" }}
    >
      <div className="text-bold text-toptrade" style={{ fontSize: "16px" }}>
        {locale.t("dashboardContest.top_trade")}
      </div>
      {status?.status === "upcoming" ||
      data?.data?.length <= 0 ||
      data?.data === undefined ? (
        <div
          style={{
            color: "#A3A3A3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/images/icons/imageNotFound.png"
            style={{ width: "52px", height: "52px" }}
            alt=""
          />
          <div style={{ fontWeight: "800" }}>
            {locale.t("dashboardContest.title_no_data")}
          </div>
          <div style={{ fontSize: "12px" }}>
            {locale.t("dashboardContest.desc_no_data")}
          </div>
        </div>
      ) : (
        <>
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "16px" }}
          >
            {data?.data?.length > 0 && (
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                width={280}
              />
            )}
          </div>
          <div
            className="d-flex flex-column"
            style={{ marginTop: "32px", padding: "14px", gap: "24px" }}
          >
            {data?.data.map((e, i) => (
              <div className="d-flex justify-content-between">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#F9F9F9",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    paddingRight: "8px",
                    paddingLeft: "8px",
                    borderRadius: "24px",
                  }}
                >
                  {i === 0 ? (
                    <div style={{ width: "14px", height: "14px", backgroundColor: "#33B1FF", borderRadius: "100%" }} />
                  ) : i === 1 ? (
                    <div style={{ width: "14px", height: "14px", backgroundColor: "#F8D96A", borderRadius: "100%" }} />
                  ) : (
                    <div style={{ width: "14px", height: "14px", backgroundColor: "#50B97A", borderRadius: "100%" }} />
                  )}
                  <span style={{ fontSize: "12px" }}>
                    {e.s.replace(".iux", "")}
                  </span>
                </div>
                <div className="text-bold" style={{ fontSize: "14px" }}>
                  {fPercentExact(e.percentage)}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PieChartContest;
